<template>
  <div>
    <welcome-menu-card
      :current-language="'pt'"
      :hotel="hotel"
      :welcome="welcome"
      @click:checkin="goToFindReservation"
      @click:services="goToOnlineServices"
      @click:checkout="goToOnlineServices"
    />
    <expired-pin-modal :opened="isExpiredPin" @click:ok="onConfirm" />
  </div>
</template>

<script>
import { onMounted, ref } from "vue"
import {
  useNamespacedActions,
  useNamespacedState,
} from "vuex-composition-helpers/dist"

import { useStore } from "@/store/index"

import ExpiredPinModal from "./components/modals/ExpiredPinModal.vue"
import WelcomeMenuCard from "./components/WelcomeMenuCard.vue"

export default {
  components: { WelcomeMenuCard, ExpiredPinModal },
  setup() {
    const store = useStore()

    const { hotel, welcome } = useNamespacedState("company", [
      "hotel",
      "welcome",
    ])
    const isExpiredPin = ref(false)

    const { redirectToGuestControl } = useNamespacedActions("company", [
      "redirectToGuestControl",
    ])

    const goToFindReservation = () => {
      store.dispatch("flow/reservation/next")
    }

    async function goToOnlineServices() {
      await redirectToGuestControl()
    }

    onMounted(() => {
      const expiredPin = localStorage.getItem("expiredPin")
      if (expiredPin) {
        isExpiredPin.value = true
      }
    })

    const onConfirm = () => {
      localStorage.removeItem("expiredPin")
      isExpiredPin.value = false
    }

    return {
      goToFindReservation,
      goToOnlineServices,
      hotel,
      welcome,
      onConfirm,
      isExpiredPin,
    }
  },
}
</script>
